const emergencyEn = {
  buttons: {
    gas: 'Gas Cylinder',
    medicine: 'Emergency Medicine',
  },
  common: {
    nameLabel: 'Your Name',
    phoneLabel: 'Mobile Number',
    villageLabel: 'Village/Area',
    houseNumberLabel: 'House Number',
    detailsLabel: 'Additional Info',
    detailsPlaceholder: 'Any special instruction',
    districtLabel: 'District',
    upazillaLabel: 'Upazila',
    cancel: 'Cancel',
  },
  gas: {
    title: 'Gas Cylinder Refill',
    companyLabel: 'Gas Company',
    cylinderSizeLabel: 'Cylinder Size',
    cylinderSizePlaceholder: 'Select cylinder size',
    quantityLabel: 'Quantity',
    companies: {
      bashundhara: 'Bashundhara Gas',
      jamuna: 'Jamuna Gas',
      omera: 'Omera Gas',
      beximco: 'Beximco Gas',
      fresh: 'Fresh Gas',
      totalgaz: 'Totalgaz',
      others: 'Others',
    },
    cylinderSizeOptions: {
      "12kg": '12 kg',
      "33kg": '33 kg',
      "45kg": '45 kg',
    },
    price: {
      header: 'Price Details',
      unitPrice: 'Unit Price',
      subtotal: 'Subtotal',
      delivery: 'Delivery Charge',
      total: 'Grand Total',
      note: '* Cash on delivery available',
      unitSuffix: 'pcs',
    },
    orderNow: 'Order Now',
  },
  medicine: {
    title: 'Emergency Medicine Service',
    medicineNameLabel: 'Medicine Name',
    medicineNamePlaceholder: 'Which medicine is needed?',
    urgencyLabel: 'Urgency Level',
    urgencyOptions: {
      normal: 'Normal',
      urgent: 'Urgent',
      emergency: 'Emergency',
    },
    prescriptionLabel: 'Prescription (if any)',
    prescriptionPlaceholder: 'Doctor’s prescription or medicine details',
    uploadNote: 'Prescription upload is optional; you can upload an image or PDF.',
    uploadButton: 'Upload Prescription (Optional)',
    selectedFilePrefix: 'Selected file:',
    submit: 'Place Emergency Order',
  }
};

export default emergencyEn;


